import { ApplicantLayout } from '@platform-ui/application/components/index.js';
import { useUserHomeRoute } from '@platform-ui/utilities/Routes.js';
import { Navigate, Route, Routes } from 'react-router-dom-v5-compat';
import { AuthProvider } from './hooks/useAuth/index.js';
import { TenantProvider } from './hooks/useTenant.js';
import BeamSignIn from './pages/BeamSignIn.js';
import EmailSent from './pages/EmailSent.js';
import MagicLink from './pages/MagicLink.js';
import SignIn from './pages/SignIn.js';
import SignInWithPassword from './pages/SignInWithPassword.js';

enum IdentityPaths {
  SIGNIN = '/identity/signin',
  SIGNIN_BASIC = '/identity/basic',
  EMAIL_SENT = '/identity/emailSent',
  MAGIC_LINK = '/identity/magicLink',

  BEAM_SIGNIN = '/identity/beam/saml',
}

export default function IdentityPage({ element: Element, tenantRole, ...rest }) {
  return (
    <TenantProvider tenantRole={tenantRole}>
      <AuthProvider>
        <ApplicantLayout>
          <Element {...rest} />
        </ApplicantLayout>
      </AuthProvider>
    </TenantProvider>
  );
}

function IdentityRoutes() {
  const userHome = useUserHomeRoute();
  return (
    <Routes>
      <Route
        key={IdentityPaths.SIGNIN}
        path={IdentityPaths.SIGNIN}
        element={<IdentityPage element={SignIn} tenantRole="applicant" />}
      />
      <Route
        key={IdentityPaths.SIGNIN_BASIC}
        path={IdentityPaths.SIGNIN_BASIC}
        element={<IdentityPage element={SignInWithPassword} tenantRole="applicant" />}
      />
      <Route
        key={IdentityPaths.EMAIL_SENT}
        path={IdentityPaths.EMAIL_SENT}
        element={<IdentityPage element={EmailSent} tenantRole="applicant" />}
      />
      <Route
        key={IdentityPaths.MAGIC_LINK}
        path={IdentityPaths.MAGIC_LINK}
        element={<IdentityPage element={MagicLink} tenantRole="applicant" />}
      />
      <Route
        key={IdentityPaths.BEAM_SIGNIN}
        path={IdentityPaths.BEAM_SIGNIN}
        element={<IdentityPage element={BeamSignIn} tenantRole="advocate" />}
      />
      <Route path="*" element={<Navigate to={userHome} />} />
    </Routes>
  );
}

export { IdentityRoutes, IdentityPaths };
